// core
import React, { ReactElement } from "react";

// styles
import styles from "./Loader.module.scss";
import cx from "classnames";

// other
import Default from "../../../compare/assets/loader.gif";
import Spinner from "../../../../../images/svg/icons/spinner-loader.svg"

const loadingIcons = {
    Default
};

interface ILoaderProps {
    icon?: keyof typeof loadingIcons;
    className?: string;
    size?: "default" | "full-page";
}

const Loader: React.FC<ILoaderProps> = (props): ReactElement => {
    const { icon, size, className } = props;

    return (
        <div
            className={cx({
                [styles["loader-base"]]: !className,
                [className]: !!className,
                [styles["loader-full-page"]]: size === "full-page"
            })}>
            <div className={styles["loader-content"]}>
                <img src={Spinner} alt="Spinner icon" className={styles["spinner"]} />
                    <h2>One moment please</h2>
                    <p>We're working our LifeDirect magic</p>
            </div>
        </div>
    );
};

export default Loader;
